import React from "react";
import { Step, Stepper } from "react-form-stepper";
import { ContainerStepper } from "./styles";

const Steps = ({ steps, active }) => {
	return (
		<ContainerStepper>
			<Stepper
				connectorStyleConfig={{
					disabledColor: "#8f8f9a",
					activeColor: "#8f8f9a",
					completedColor: "#01e59b",
					size: 1,
				}}
				styleConfig={{
					activeBgColor: "#01e59b",
					inactiveBgColor: "#8F8F9A",

					activeTextColor: "#13141b",
					inactiveTextColor: "#13141b",

					completedBgColor: "#01e59b",
					completedTextColor: "#13141b",

					size: "1.5rem",
					circleFontSize: "0.625rem",
					labelFontSize: "0.625rem",
					fontWeight: "700",
				}}
				activeStep={active}
			>
				{steps.map((item, index) => (
					<Step key={item} itemID="blabla" label={item.label} />
				))}
			</Stepper>
		</ContainerStepper>
	);
};

export default Steps;
